module.exports = __webpack_public_path__ + "img/image16.0aec5fa2.jpg";